// Address-bar contract for chats: /c/<id> opens a chat, /w/<workspace>/c/<id>/m/<message>
// opens it at a message (only inside the signed-in workspace). Old bot /c/<id>/m/<message>
// links are compatibility aliases under the current session's normal context endpoint ACL.
export type ChatRoute = { conversationId: string; targetId?: string };

export function chatPath(conversationId: string): string {
  return `/c/${conversationId}`;
}

export function parseChatRoute(pathname: string, workspaceId: string): ChatRoute | null {
  const message = pathname.match(/^\/w\/([^/]+)\/c\/([^/]+)\/m\/([^/]+)$/);
  if (message) return message[1] === workspaceId ? { conversationId: message[2]!, targetId: message[3]! } : null;
  const legacyMessage = pathname.match(/^\/c\/([^/]+)\/m\/([^/]+)$/);
  if (legacyMessage) return { conversationId: legacyMessage[1]!, targetId: legacyMessage[2]! };
  const chat = pathname.match(/^\/c\/([^/]+)$/);
  return chat ? { conversationId: chat[1]! } : null;
}

// A newly selected chat gets its own history entry so Back/Forward move between chats;
// reopening the chat already in the address bar (initial load, popstate) adds none.
export function chatHistoryUpdate(pathname: string, conversationId: string): string | null {
  const path = chatPath(conversationId);
  return pathname === path ? null : path;
}

// The owned mobile chat entry sits above its list. Reopening/switching replaces it;
// a different account must establish its own list rather than reuse another marker.
export function updateMobileChatHistory(history: Pick<History, 'state' | 'replaceState' | 'pushState'>, path: string, owner: string): void {
  const state = history.state;
  if (state?.pmChatMobile === owner) { history.replaceState(state, '', path); return; }
  history.replaceState({ pmChatList: owner }, '', '/');
  history.pushState({ pmChatMobile: owner }, '', path);
}
